import { Box } from "@mui/material";
import { Divider } from "@src/appV2/redesign/system/ui-components";

export function ShiftCardDivider() {
  return (
    <Box sx={{ paddingY: 5 }}>
      <Divider color="primary" />
    </Box>
  );
}
